import React, { Component } from 'react';
import {
   Card, CardBody, Col, Table, Button, UncontrolledTooltip, FormGroup, Badge,
} from 'reactstrap';
import { withTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import Moment from 'moment';
import swal from 'sweetalert';
import ReactPaginate from 'react-paginate';
import AsyncSelect from 'react-select/lib/Async';

import CustomersModal from './CustomersModal';
import CommonService from '../../../services/CommonService';
import SelectService from '../../../services/SelectService';
import AddPaymentModal from './AddPaymentModal';
import PaymentListsModal from '../../../shared/modals/PaymentListsModal';
import TransactionListModal from '../../../shared/modals/TransactionListModal';
import global from '../../../global';

class CustomersLists extends Component {
   constructor() {
      super();
      this.state = {
         realList: [],
         list: [],
         modal: false,
         formdata: {
            locationId: 0,
         },
      };
      this.isLoading = false;
      this.userdata = JSON.parse(localStorage.getItem('userData'));
      this.toggleModal = this.toggleModal.bind(this);
      this.addToggle = this.addToggle.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.changeLocation = this.changeLocation.bind(this);
      this.updateCustomerStatus = this.updateCustomerStatus.bind(this);
      this.customerName = '';
   }

   componentDidMount() {
      this.isLoading = true;
      this.onLoadCustomers();
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   onLoadCustomers = async (locationchange = '') => {
      try {
         const location = (this.userdata.type !== '1' && this.userdata.type !== '5' ? `/locationid/${this.userdata.location_id}` : '');
         const lochange = (locationchange !== '' ? `/locationid/${locationchange}` : '');
         const response = await CommonService.getRows(`customers${location}${lochange}`);
         this.setState({ list: response, realList: response });
         this.handleClick();
      } catch (err) {
         console.log('Error: ', err.message);
      }
      this.isLoading = false;
   }

   getLocations = async (newValue) => {
      this.isLoading = true;
      const formData = { searchFor: newValue, searchType: 9 };
      const options = [];
      if (this.isLoading) {
        await SelectService.listLocationOptions(formData).then((response) => {
          if (response) {
            response.map(opt => (
              options.push({
                value: opt.location_id,
                label: opt.location_name,
              })
            ));
          }
        }).catch((error) => {
          console.log('Error: ', error.message);
        });
        this.isLoading = false;
      }

      return options;
   }

   paymentToggle = (e, customerId, balance = 0, colect = 0, cusName = '') => {
      e.preventDefault();
      this.toggleModal();
      this.executeModal = 'addpayment';
      this.customerName = cusName;
      this.setState({
         formdata: {
            amount: 0,
            paymentType: '',
            bank: '',
            chequeNum: '',
            chequeDate: new Date(),
            chequeDate_txt: Moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            date_added: new Date(),
            date_added_txt: Moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            accountNum: '',
            accountName: '',
         },
         balance,
         errorMsg: '',
      });
      this.handleSubmit = (ev) => { this.submitPayment(ev, customerId, balance, colect); };
   }

   submitPayment = async (e, customerId, balance = 0, colect = 0) => {
      e.preventDefault();
      const { formdata, list } = this.state;
      const amount = formdata.amount ? parseFloat(formdata.amount, 10) : 0;
      balance = parseFloat(balance, 10);
      colect = parseFloat(colect, 10);
      formdata.customer = customerId;
      formdata.balance = balance;
      formdata.addedBy = this.userdata.user_id;
      formdata.locationid = this.userdata.location_id;
      formdata.date_added = this.userdata.date_added_txt;

      if (formdata.amount && (formdata.paymentType === '0' || (formdata.paymentType === '1' && formdata.bank && formdata.chequeNum && formdata.chequeDate && formdata.accountNum && formdata.accountName))) {
         if (amount > balance) {
            this.setState({ errorMsg: 'Enter amount less than or equal to balance.' });
         } else {
            const response = await CommonService.insertData('addcollectionpayment', formdata);
            if (response === true) {
               list.filter((listResp) => {
                  if (listResp.customer_id === customerId) {
                    listResp.current_balance = balance >= amount ? balance - amount : 0;
                    listResp.collection = colect + amount;
                  }
                  return listResp;
               });
               this.setState({ list, errorMsg: '', modal: false });
            } else {
              alert();
               this.setState({ errorMsg: response });
            }
         }
      } else {
         this.setState({ errorMsg: 'Required field is empty.' });
      }
   }

   viewPaymentList = (e, customerId, cusName = '') => {
      e.preventDefault();
      this.executeModal = 'viewpayment';
      this.customerName = cusName;
      this.toggleModal();
      this.setState({ customerId });
   }

   viewTransactionList = (e, customerId, cusName = '') => {
      e.preventDefault();
      this.executeModal = 'viewtransaction';
      this.customerName = cusName;
      this.toggleModal();
      this.setState({ customerId });
   }

   handleChange = (e, fieldName = '') => {
    if (fieldName === 'number') {
       const { name, value } = e.target;
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, [name]: value.replace(/[^0-9.]/g, '') },
       }));
    } else if (fieldName === 'date') {
       const date = new Date(e);
       const dateText = Moment(date).format('YYYY-MM-DD HH:mm:ss');
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, chequeDate: date, chequeDate_txt: dateText },
       }));
    } else if (fieldName === 'date_added') {
       const dateAdded = new Date(e);
       const dateText = Moment(dateAdded).format('YYYY-MM-DD HH:mm:ss');
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, date_added: dateAdded, date_added_txt: dateText },
       }));
    } else if (fieldName === 'locationid') {
      let mylocationId = '';
      if (e) {
         mylocationId = e.value;
      }

      this.setState(prevState => ({
        formdata: { ...prevState.formdata, mylocationId },
      }));
  } else {
       const { name, value } = e.target;
       this.setState(prevState => ({
          formdata: { ...prevState.formdata, [name]: value },
       }));
    }
   }

   handleChangeFromCustomer = (e, fieldName) => {
     if (fieldName === 'location') {
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, location: e.value, locationName: e.label },
       }));
     } else if (fieldName === 'locationType') {
       const { name, value } = e.target;
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata, [name]: value, location: '', locationName: '',
         },
       }));
     } else {
       const { name, value } = e.target;
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, [name]: value },
       }));
     }
   }

   updateCustomerStatus = (e, id, status) => {
      e.preventDefault();
      const statusTxt = status === 1 ? 'activate' : status === 2 ? 'remove' : 'deactivate';
      swal({
         title: 'Confirmation',
         text: `Are you sure you want to ${statusTxt} this customer?`,
         icon: 'warning',
         closeOnClickOutside: false,
         buttons: {
            yes: 'YES',
            no: 'NO',
         },
      }).then((name) => {
         name = name.toLowerCase();
         const customerdata = { customerstatus: status, customerid: id };

         if (name === 'yes') {
            CommonService.updateData('updatecustomerstatus', customerdata).then((response) => {
               if (response === true) {
                  this.onLoadCustomers();
                  this.setState({ errorMsg: '', modal: false });
               } else {
                  swal('', 'Something went wrong!', 'error');
               }
            }).catch((error) => {
               console.log(error);
            });
         }
      });
   }

   addSubmitForm = async (e) => {
     e.preventDefault();
     const { formdata } = this.state;

     if (['1', '5'].indexOf(this.userdata.type) === -1) {
        formdata.type = this.userdata.type;
        formdata.location = this.userdata.location_id;
     }
     if (formdata.name && formdata.currentBalance && formdata.type && formdata.location && formdata.number) {
       formdata.log_by = this.userdata.user_id;
       const response = await CommonService.insertData('add_customer', formdata);

       if (response.msg_resp === true) {
         this.onLoadCustomers();
         this.setState({ errorMsg: '', modal: false });

         swal({
           title: 'New customer was added!',
           text: 'Would you like to add a new customer?',
           icon: 'success',
           closeOnClickOutside: false,
           buttons: {
             no: 'NOPE',
             yes: 'ADD NEW',
           },
         }).then((name) => {
           name = name.toLowerCase();

           if (name === 'yes') {
             this.addToggle();
           }
         });
       } else {
          this.setState({ errorMsg: response.msg_resp });
       }
     } else {
       this.setState({ errorMsg: 'Required fields are empty.' });
     }
   }

   changeLocation(e) {
      e.preventDefault();
      const { formdata } = this.state;
      const locMy = formdata.mylocationId !== undefined ? formdata.mylocationId : '';
      this.onLoadCustomers(locMy);
   }

   handleClick(event = '') {
      const selected = event !== '' ? event.selected + 1 : 1;
      const { realList } = this.state;

      const lastPost = selected * 10;
      const firstPost = lastPost - 10;

      const newList = realList.slice(firstPost, lastPost);
      this.setState({ list: newList });
   }

   toggleModal() {
    this.setState(prevState => ({ modal: !prevState.modal }));
   }

   editToggle(id) {
     this.executeModal = 'editcustomer';
     this.toggleModal('Edit');
     this.setState({ errorMsg: '' });
     this.showPassField = false;
     // get location info
     CommonService.getRows(`get_single_row/customers/customer_id/${id}`).then((result) => {
       if (result) {
          const currentBalance = global.parseToNumber(result.current_balance, 'float');
          const transactionBalance = global.parseToNumber(result.transaction_balance, 'float');
         this.setState({
           formdata: {
             name: result.customer_name,
             number: result.number,
             current_balance: currentBalance >= transactionBalance ? global.parseToNumber(global.numberFormat(currentBalance - transactionBalance, 2), 'float') : 0,
             transaction_balance: transactionBalance,
           },
         });
       }
     }).catch((error) => {
       console.log(error);
     });
     // submit form
     this.handleSubmit = (e) => { this.editSubmitForm(e, id); };
   }

   editSubmitForm(e, customerId) {
     e.preventDefault();
     const { formdata } = this.state;
     // formdata.customer_id = customerId;

     if (formdata.name && formdata.number && formdata.current_balance) {
       const currBalance = global.parseToNumber(global.numberFormat(formdata.current_balance, 2), 'float') + global.parseToNumber(global.numberFormat(formdata.transaction_balance, 2), 'float');

       const dodata = {
          customer_name: formdata.name, number: formdata.number, current_balance: currBalance, log_by: this.userdata.user_id,
       };
       CommonService.updateData(`update_single_row/customers/customer_id/${customerId}`, dodata).then((result) => {
         if (result === 1) {
            this.onLoadCustomers();
            this.setState({ errorMsg: '', modal: false });
         } else {
           this.setState({ errorMsg: result });
         }
       }).catch((error) => {
         console.log(error);
       });
     } else {
       this.setState({ errorMsg: 'Required fields are empty.' });
     }
   }

   addToggle() {
     this.executeModal = 'addcustomer';
     this.toggleModal('Add');
     this.showPassField = true;
     this.setState({
       formdata: {
         addedBy: this.userdata.user_id,
       },
     });
     this.handleSubmit = (e) => { this.addSubmitForm(e); };
   }

   render() {
      const {
         list, modal, errorMsg, formdata, balance, customerId, realList,
      } = this.state;
      const custNamer = this.customerName;

      const mycustomerName = custNamer !== '' ? ` - ${custNamer}` : '';

      return (
         <Col md={12}>
            {
               this.executeModal === 'addpayment' ? (
                  <AddPaymentModal
                     title={`Payment ${mycustomerName}`}
                     modal={modal}
                     toggle={this.toggleModal}
                     formdata={formdata}
                     handleChange={this.handleChange}
                     handleSubmit={this.handleSubmit}
                     errorMsg={errorMsg}
                     balance={balance}
                  />
               ) : this.executeModal === 'viewpayment' ? (
                  <PaymentListsModal
                     title={`Payment Lists ${mycustomerName}`}
                     modal={modal}
                     toggle={this.toggleModal}
                     id={customerId}
                     identifier="customer"
                  />
               ) : this.executeModal === 'viewtransaction' ? (
                  <TransactionListModal
                     title={`Transaction Lists ${mycustomerName}`}
                     modal={modal}
                     toggle={this.toggleModal}
                     id={customerId}
                     identifier="customer"
                  />
               ) : this.executeModal === 'addcustomer' ? (
                  <CustomersModal
                    title="Add Customer"
                    modal={modal}
                    showPassField={this.showPassField}
                    toggle={this.toggleModal}
                    handleChange={this.handleChangeFromCustomer}
                    handleSubmit={this.handleSubmit}
                    postValue={formdata}
                    errorMsg={errorMsg}
                  />
               ) : this.executeModal === 'editcustomer' ? (
                  <CustomersModal
                    title="Edit Customer"
                    modal={modal}
                    toggle={this.toggleModal}
                    handleChange={this.handleChangeFromCustomer}
                    handleSubmit={this.handleSubmit}
                    postValue={formdata}
                    errorMsg={errorMsg}
                  />
               ) : ''
            }
            <Card className="panel panel--primary" id="users_table">
               <CardBody className="panel__body">
                  <div className="panel__title bg_blue">
                     <h5 className="bold-text">CUSTOMERS</h5>
                     <div className="panel__btns">
                       <Button onClick={this.addToggle} className="rounded text-white" size="sm" outline><i className="fa fa-user-plus m-r-4 m-l-3" /> <span>Add Customer</span></Button>
                     </div>
                  </div>
                  <div className="panel__content">
                     {/* Search Form */}
                     <form className="form form--horizontal xw-320" onSubmit={this.changeLocation}>
                        <div className="form__form-group m-b-7">
                           <div className="form__form-group-field m-l-0 p-0 full-100">
                              <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Location:</span>
                              <div className="form__form-group-icon mh-38"><i className="fa fa-map-marker-alt text-gray" /></div>
                              <AsyncSelect
                                 name="locationid"
                                 cacheOptions
                                 loadOptions={this.getLocations}
                                 defaultOptions
                                 isClearable
                                 className="react-select"
                                 classNamePrefix="react-select"
                                 placeholder="Location name..."
                                 onChange={e => this.handleChange(e, 'locationid')}
                              />
                              <button type="submit" className="form__form-group-button bg-primary mh-38 m-l-2">Search</button>
                           </div>
                        </div>
                     </form>

                     <Table responsive striped className="doResTable">
                        <thead>
                           <tr>
                              <th>Code</th>
                              <th>Customer Name</th>
                              {
                                 this.userdata && (this.userdata.type === '1' || this.userdata.type === '5') && (
                                    <>
                                    <th className="text-center">Location</th>
                                    <th width="10%" className="text-center">Type</th>
                                    </>
                                 )
                              }
                              <th className="text-center">Old Balance</th>
                              <th className="text-center">Collection</th>
                              <th className="text-center">Total Sales</th>
                              <th className="text-center">Total Payment</th>
                              <th className="text-center">Accounts Receivable</th>
                              <th className="text-center">New Balance</th>
                              <th width="15%" className="text-center">Last Collection Date</th>
                              <th className="text-center">Status</th>
                              <th className="text-center">Options</th>
                              <th className="text-center">Action</th>
                           </tr>
                        </thead>
                        <tbody>
                           {
                              list !== false || list.length > 0 ? list.map((item, i) => {
                                 const oldBalance = parseFloat(item.old_balance, 10);
                                 const accReceivable = parseFloat(item.receivable, 10);
                                 const collection = parseFloat(item.collection, 10);
                                 const totalPayment = parseFloat(item.total_payment, 10);
                                 const totalSales = parseFloat(item.total_sales, 10);
                                 const currentBalance = parseFloat(item.current_balance, 10);

                                 // status for button
                                 item.status = parseInt(item.status, 10);
                                 let statusColor = 'success';
                                 let btnColor = 'danger';
                                 let btnIcon = 'times';
                                 let statusText = 'Deactivate';
                                 if (item.status === 1) {
                                   statusColor = 'danger';
                                   btnColor = 'success';
                                   btnIcon = 'check';
                                   statusText = 'Activate';
                                 }

                                 return (
                                    <tr key={`cust_tr${i + 1}`} className="text-center">
                                    <td className="text-left">{item.customer_number}</td>
                                       <td className="text-left">{item.customer_name}</td>
                                       {
                                          this.userdata && (this.userdata.type === '1' || this.userdata.type === '5') && (
                                             <>
                                                <td className="text-left text-center">{item.location_from}</td>
                                                <td>{item.type === '2' ? 'Direct Buyer' : item.type === '1' ? 'Store' : '-'}</td>
                                             </>
                                          )
                                       }
                                       <td className="text-warning">{oldBalance > 0 ? parse(`&#x20B1; ${global.numberFormat(oldBalance)}`) : '-'}</td>
                                       <td className="text-success">{collection > 0 ? parse(`&#x20B1; ${global.numberFormat(collection)}`) : '-'}</td>
                                       <td className="text-success">{totalSales > 0 ? parse(`&#x20B1; ${global.numberFormat(totalSales)}`) : '-'}</td>
                                       <td className="text-success">{totalPayment > 0 ? parse(`&#x20B1; ${global.numberFormat(totalPayment)}`) : '-'}</td>
                                       <td className="text-primary">{accReceivable > 0 ? parse(`&#x20B1; ${global.numberFormat(accReceivable)}`) : '-'}</td>
                                       <td className="text-danger">{currentBalance > 0 ? parse(`&#x20B1; ${global.numberFormat(currentBalance)}`) : 0}</td>
                                       <td>{item.last_payment_date ? item.last_payment_date : '--'}</td>
                                       <td className="text-center" width="130px"><Badge color={statusColor}>{global.statusType[item.status]}</Badge></td>
                                       <td className="text-center ab">
                                       {
                                          currentBalance > 0 && (
                                           <>
                                            <Button color="success" className="btn-xs" onClick={e => this.paymentToggle(e, item.customer_id, currentBalance, collection, item.customer_name)} id={`paymentbtn${i + 1}`} outline><span className="fa fa-money-bill-alt" /></Button>
                                            <UncontrolledTooltip placement="bottom" target={`paymentbtn${i + 1}`}>Add Payment</UncontrolledTooltip>
                                           </>
                                          )
                                       }
                                       <Button color="success" className="btn-xs" id={`viewpayments${i + 1}`} onClick={e => this.viewPaymentList(e, item.customer_id, item.customer_name)} outline><span className="fa fa-money-check-alt" /></Button>
                                       <UncontrolledTooltip placement="bottom" target={`viewpayments${i + 1}`}>View Payment Lists</UncontrolledTooltip>

                                       {/* transactions list */}
                                       <Button color="warning" className="btn-xs" id={`viewtransactions${i + 1}`} onClick={e => this.viewTransactionList(e, item.customer_id, item.customer_name)} outline><span className="fa fa-list-alt" /></Button>
                                       <UncontrolledTooltip placement="bottom" target={`viewtransactions${i + 1}`}>View Transaction Lists</UncontrolledTooltip>
                                       </td>
                                       <td>
                                          {
                                          /* Edit */
                                             item.status === 0 && (
                                                <>
                                                   <Button color="primary" className="btn-xs" onClick={() => this.editToggle(item.customer_id)} id={`usereditbtn${i + 1}`} outline><span className="lnr lnr-pencil" /></Button>
                                                   <UncontrolledTooltip placement="bottom" target={`usereditbtn${i + 1}`}>Edit</UncontrolledTooltip>
                                                </>
                                             )
                                          }
                                          {/* Activate / Deactivate */}
                                          <Button color={btnColor} className="btn-xs" onClick={e => this.updateCustomerStatus(e, item.customer_id, item.status)} id={`statusbtn${i + 1}`} outline><span className={`fa fa-${btnIcon}`} /></Button>
                                          <UncontrolledTooltip placement="bottom" target={`statusbtn${i + 1}`}>{statusText}</UncontrolledTooltip>

                                          {/* Permanent Delete */}
                                          <Button color="danger" className="btn-xs" onClick={e => this.updateCustomerStatus(e, item.customer_id, 2)} id={`trashbtn${i + 1}`} outline><span className="fa fa-trash" /></Button>
                                          <UncontrolledTooltip placement="bottom" target={`trashbtn${i + 1}`}>Permanent Delete</UncontrolledTooltip>
                                       </td>
                                    </tr>
                                 );
                              }) : (
                                 <tr className="text-center">
                                    <td colSpan="12">No data available..</td>
                                 </tr>
                              )
                           }
                        </tbody>
                     </Table>
                     <FormGroup className={list === false || (realList.length / 10) <= 1 ? 'display-none' : ''}>
                        <ReactPaginate
                           previousLabel="<<"
                           nextLabel=">>"
                           breakLabel="..."
                           breakClassName="break-me"
                           pageCount={realList.length / 10}
                           onPageChange={this.handleClick}
                           marginPagesDisplayed={0}
                           pageRangeDisplayed={2}
                           containerClassName="list-pagination"
                           activeClassName="active"
                        />
                     </FormGroup>
                  </div>
               </CardBody>
            </Card>
         </Col>
      );
   }
}

export default withTranslation('common')(CustomersLists);
